module.exports = __webpack_public_path__ + "img/print.009425f3.svg";